//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";
import ReplacementCodesTable from "@/pages/StoreManagement/components/replacementCodesTable.vue";

export default {
  name: "geographyTab",
  props: ["value"],
  components: {
    ReplacementCodesTable,
  },
  data: () => ({
    validForm: false,
    tab: "traits",
    retailerList: [],
    insigniaList: [],
    chainList: [],
    districtList: [],
    countyList: [],
    borroughList: [],
  }),
  methods: {
    required,
    noValidation,
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    updateData() {
      this.$emit("value", this.value);
    },
    updateCode: function(event) {
      let index = this.value.store_codes.map( (i) => (i.id)).indexOf(event.id);
      this.value.store_codes.splice(index, 1, event)
      this.updateData();
    },
  },
  watch: {
    value: function (newValue) {
      this.value = newValue;
    },
  },
};
